import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

function Field({ id, label, children }) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-xs text-zinc-600">{label}</Label>
      {children}
    </div>
  );
}

/** Clinical credentials + practice fields (no designations). */
export default function DoctorProfileFields({ form, set, specs = [] }) {
  return (
    <div className="grid sm:grid-cols-2 gap-4" data-testid="doctor-profile-fields">
      <Field id="pf-spec" label="Specialisation">
        <select
          id="pf-spec"
          className="h-10 w-full border rounded-md px-3 text-sm"
          value={form.specialization}
          onChange={(e) => set({ specialization: e.target.value })}
        >
          <option value="">—</option>
          {form.specialization && !specs.find((s) => s.name === form.specialization) && (
            <option value={form.specialization}>{form.specialization}</option>
          )}
          {specs.map((s) => (
            <option key={s.id || s.name} value={s.name}>{s.name}</option>
          ))}
        </select>
      </Field>
      <Field id="pf-spec2" label="Secondary specialisation">
        <Input id="pf-spec2" value={form.secondary_specialization}
          onChange={(e) => set({ secondary_specialization: e.target.value })}
          placeholder="Optional" />
      </Field>
      <Field id="pf-qual" label="Qualifications">
        <Input id="pf-qual" placeholder="MBBS, MD, DNB…" value={form.qualifications}
          onChange={(e) => set({ qualifications: e.target.value })} />
      </Field>
      <Field id="pf-fellow" label="Fellowship / additional training">
        <Input id="pf-fellow" value={form.fellowship}
          onChange={(e) => set({ fellowship: e.target.value })} />
      </Field>
      <Field id="pf-reg" label="Registration number">
        <Input id="pf-reg" value={form.registration_number}
          onChange={(e) => set({ registration_number: e.target.value })} />
      </Field>
      <Field id="pf-council" label="Medical council">
        <Input id="pf-council" placeholder="NMC / State council" value={form.medical_council}
          onChange={(e) => set({ medical_council: e.target.value })} />
      </Field>
      <Field id="pf-opd" label="OPD days / hours">
        <Input id="pf-opd" placeholder="Mon–Fri 9:00–13:00" value={form.opd_days}
          onChange={(e) => set({ opd_days: e.target.value })} />
      </Field>
      <Field id="pf-fee" label="Consultation fee (₹)">
        <Input id="pf-fee" type="number" min={0} value={form.consultation_fee}
          onChange={(e) => set({ consultation_fee: e.target.value })} />
      </Field>
      <Field id="pf-exp" label="Years of experience">
        <Input id="pf-exp" type="number" min={0} max={80} value={form.experience_years}
          onChange={(e) => set({ experience_years: e.target.value })} />
      </Field>
      <Field id="pf-lang" label="Languages">
        <Input id="pf-lang" placeholder="English, Hindi, Telugu" value={form.languages}
          onChange={(e) => set({ languages: e.target.value })} />
      </Field>
      <div className="sm:col-span-2">
        <Field id="pf-interests" label="Clinical interests">
          <Input id="pf-interests" value={form.clinical_interests}
            onChange={(e) => set({ clinical_interests: e.target.value })} />
        </Field>
      </div>
    </div>
  );
}
